import React from 'react';
import TicketSelectOption from './TicketSelectOption';
import { getProviderCategoryContext, getProviderReferenceLabel } from '../../utils/providerCategory';

export const getProviderOptionLabel = (provider) => (
  provider?.label ||
  [
    provider?.provider_id?.name || provider?.provider_id?.code || provider?.code,
    provider?.type,
    provider?.source?.name,
    getProviderReferenceLabel(provider?.currency, true),
    getProviderReferenceLabel(provider?.country)
  ].filter(Boolean).join(' / ') ||
  'L1 Provider'
);

const ProviderSelectOption = ({ provider, disabled, onClick, status, statusTone }) => {
  return (
    <TicketSelectOption
      disabled={disabled}
      onClick={onClick}
      label={getProviderOptionLabel(provider)}
      description={getProviderCategoryContext(provider)}
      status={status}
      statusTone={statusTone}
    />
  );
};

export default ProviderSelectOption;
